import {createAction, createAsyncThunk, createReducer} from '@reduxjs/toolkit';

import {ENDPOINTS} from 'constants/endpoints';
import {PAYMENTS} from 'desktop/pages/checkout/constants/paymentStep';
import {apiConfig} from 'libs/api/api';

import {PaymentMethodsType} from 'types/PaymentMethodsType';

export const initialState: PaymentMethodsType = {
    list: {},
    status: 'PENDING',
};
export const changePaymentMethod = createAction<PAYMENTS>('CHECKOUT@CHANGE_PAYMENT_METHODS');

export const getPaymentMethods = createAsyncThunk<{data: PaymentMethodsType['list']}>(
    'CHECKOUT@GET_PAYMENT_METHODS',
    () =>
        apiConfig.instanceGusaBackend({
            method: 'get',
            params: {
                specialSortList: true,
            },
            url: `${ENDPOINTS.CHECKOUT_GET_PAYMENTS}`,
        }),
);

export const resetPaymentMethods = createAction('CHECKOUT@RESET_PAYMENT_METHODS');

/**
 * paymentMethods reducer
 *
 * @return {PaymentMethodsType} - payment Methods state
 */
export const paymentMethods = createReducer<PaymentMethodsType>(initialState, builder => {
    builder
        .addCase(getPaymentMethods.fulfilled, (state, action) => ({
            ...state,
            list: action.payload.data,
            status: 'FULFILLED',
        }))
        .addCase(getPaymentMethods.pending, state => ({
            ...state,
            status: 'PENDING',
        }))
        .addCase(resetPaymentMethods, () => initialState);
});
